import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage.js";
import Country from "@/models/Country/Country";
import Region from "@/models/Region/Region.js";

export default class TourNightStay extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = "tour-night-stay";

    /**
     *
     * @type {string}
     */
    static entity = "tourNightStays";

    static fields() {
        return {
            id: this.attr(null),
            rate_hawk_eid: this.attr(null),
            featured_public_image_id: this.attr(null),
            country_id: this.attr(null),
            region_id: this.attr(null),
            title: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            featuredPublicImage: this.belongsTo(
                PublicImage,
                "featured_public_image_id",
            ),
            country: this.belongsTo(Country, "country_id"),
            region: this.belongsTo(Region, "region_id"),
        };
    }
}
